import React, { useEffect, useState, useContext } from "react";
import request from "../../services/request";
import { Link, Redirect, useHistory } from "react-router-dom";
import { Dropdown } from "react-bootstrap"; /* added line */
import avatar from "../../../images/avatar/announcement-logo.png"; /* added line */
import { useTranslation } from "react-i18next"; /* Added Line */
import { ThemeContext } from "../../../context/ThemeContext";
import { formatDateNonTime } from "../../utils";
import "../../../scss/bg.css";

export default function Home() {
  const { restriction, surecler, changeSpinnerStatus, changeNotificationTabStatus, notificationTabStatus, notification } = useContext(ThemeContext);
  const [configData, setConfigData] = useState(null);
  const [seeAll, setSeeAll] = useState(false);
  const [t, i18n] = useTranslation(); /* Added Line */

  useEffect(() => {
    fetchConfigData();
  }, []);
  
  const fetchConfigData = () => {
    request({
      url: "talep-girisi/counts",
      method: "GET",
    }, changeSpinnerStatus).then((response) => {
      if (response.responseStatus === "SUCCESS") {
        setConfigData(response.body);
        setSeeAll(response.body.ikiliFormat);
      }
    });
  };

  const createListforAnnouncement = () => {
    return notification.map((duyurum, index) => {
      const { baslik, icerik, tarih, id, okumusUserId } = duyurum;
      return (
        <tr key={index} className={okumusUserId ? '' : 'bg-notification'}>
          <td>
            <div className="media align-items-center">
              <img
                className="mr-3 img-fluid rounded"
                src={'/static/media/announcement-logo.86190bf4.png'}
                width={30}
                alt={baslik +' icon'}
              />
              <div className="media-body">
                <h5 className="mb-1">
                  <Link to={`/Duyuru/${id}`}>{baslik}</Link>
                </h5>
                <h4>
                  <Link to={`/Duyuru/${id}`}>
                    {configData && configData.duyuruDetaylari}
                  </Link>
                </h4>
              </div>
            </div>
          </td>
          <td>
            <h6 className="mb-0 pr-5">
              <Link to={`/Duyuru/${id}`}>{icerik}</Link>
            </h6>
            <h4>
                <Link to={`/Duyuru/${id}`}>
                  {configData && configData.duyuruDetaylari}
                </Link>
            </h4>
          </td>
          <td>
            <div className="d-flex align-items-center">
              <div>
                <h6>{formatDateNonTime(tarih)}</h6>
              </div>
            </div>
          </td>
        </tr>
      );
    });
  };

  return (
    <>
      {(restriction) ? <Redirect to={'/dosyalar'} /> :
        <>
          <div className="form-head d-flex mb-3 mb-md-5 align-items-start">
            <div className="mr-auto d-none d-lg-block">
              <h3 className="text-dark font-w600">
                {t("anaSayfa.glasaHosGeldiniz")}
              </h3>
              <p className="mb-0">{t("anaSayfa.avukatlikYoneticisi")}</p>
            </div>

            {/* <div className="input-group search-area ml-auto d-inline-flex">
          <input
            type="text"
            className="form-control"
            placeholder="Arama Yap..."
          />
          <div className="input-group-append">
            <span className="input-group-text">
              <i className="flaticon-381-search-2"></i>
            </span>
          </div>
        </div> */}
          </div>
          <div className="row">
            <div className="col-xl-12 col-xxl-12">
              <div className="row">
                {(surecler.indexOf("bekleyen") > -1) ?
                  <>
                    <div className="col-xl-4 col-lg-4 col-sm-4">
                      <div className="widget-stat card bg-danger">
                        <div className="card-body  p-4">
                          <div className="media">
                            <span className="mr-3">
                              <i className="flaticon-381-hourglass"></i>
                            </span>
                            <div className="media-body text-white text-right">
                              <p className="mb-1">
                                <Link className={"home-link"} to={"/bekleyen-talepler"}>
                                  {t("anaSayfa.bekleyenTalepler")}
                                </Link>
                              </p>
                              <h4>
                                {(seeAll) ? <><Link
                                  className={"home-link"}
                                  to={"/bekleyen-talepler"}
                                >
                                  {configData && configData.bekleyenA}
                                </Link>
                                  <span style={{ color: '#ffffff' }}>/</span>
                                  <Link
                                    className={"home-link"}
                                    to={"/bekleyen-talepler?ikiliFormat=true"}
                                  >

                                    {configData && configData.bekleyenB}
                                  </Link></>

                                  : <Link
                                    className={"home-link"}
                                    to={"/bekleyen-talepler"}
                                  >
                                    {configData && configData.bekleyenA}
                                  </Link>}
                              </h4>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </> : null}


                {(surecler.indexOf("sureci_devam_ediyor") > -1) ? <>
                  <div className="col-xl-4 col-lg-4 col-sm-4">
                    <div className="widget-stat card bg-light">
                      <div className="card-body p-4">
                        <div className="media">
                          <span className="mr-3 bg-light">
                            <i className="flaticon-381-user-9"></i>
                          </span>
                          <div className="media-body text-white text-right">
                            <p className="mb-1">
                              <Link className={"home-link"} to={"/süreci-devam-ediyor?surecDevamEdiyor=true"}>
                                {t("anaSayfa.sureciDevamEdenTalepler")}
                              </Link>
                            </p>

                            <h4>
                              {(seeAll) ? <><Link
                                className={"home-link"}
                                to={"/süreci-devam-ediyor?surecDevamEdiyor=true"}
                              >
                                {configData && configData.surecDevamEdiyorA}
                              </Link>
                                <span style={{ color: '#ffffff' }}>/ </span>
                                <Link
                                  className={"home-link"}
                                  to={"/süreci-devam-ediyor?ikiliFormat=true&surecDevamEdiyor=true"}
                                >
                                  {configData && configData.surecDevamEdiyorB}
                                </Link></>

                                : <Link
                                  className={"home-link"}
                                  to={"/süreci-devam-ediyor?surecDevamEdiyor=true"}
                                >
                                  {configData && configData.surecDevamEdiyorA}
                                </Link>}
                            </h4>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </> : null}

                {(surecler.indexOf("yeni_talepler") > -1) ? <>
                  <div className="col-xl-4 col-lg-4 col-sm-4">
                    <div className="widget-stat card bg-info">
                      <div className="card-body p-4">
                        <div className="media">
                          <span className="mr-3">
                            <i className="flaticon-381-list-1"></i>
                          </span>
                          <div className="media-body text-white text-right">
                            <p className="mb-1">
                              <Link
                                className={"home-link"}
                                to={"/yönlendirilmiş-talepler"}
                              >
                                {t("anaSayfa.yeniTalepler")}
                              </Link>
                            </p>                            
                            <h4>
                              {(seeAll) ? <><Link
                                className={"home-link"}
                                to={"/yönlendirilmiş-talepler"}
                              >
                                {configData && configData.yonlendirilmisA}
                              </Link>
                                <span style={{ color: '#ffffff' }}>/</span>
                                <Link
                                  className={"home-link"}
                                  to={"/yönlendirilmiş-talepler?ikiliFormat=true"}
                                >

                                  {configData && configData.yonlendirilmisB}
                                </Link></>

                                : <Link
                                  className={"home-link"}
                                  to={"/yönlendirilmiş-talepler"}
                                >
                                  {configData && configData.yonlendirilmisA}
                                </Link>}
                            </h4>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </> : null}

                {(surecler.indexOf("devam_edenler") > -1) ? <>
                  <div className="col-xl-4 col-lg-4 col-sm-4">
                    <div className="widget-stat card bg-muted">
                      <div className="card-body p-4">
                        <div className="media">
                          <span className="mr-3 bg-light">
                            <i className="flaticon-381-list"></i>
                          </span>
                          <div className="media-body text-right">
                            <p className="mb-1">
                              <Link

                                to={"/süreç-devam-ediyor"}
                              >
                                {t("anaSayfa.surecDevamEdenTalepler")}
                              </Link>
                            </p>
                            <h4>
                              {(seeAll) ? <><Link

                                to={"/süreç-devam-ediyor"}
                              >
                                {configData && configData.devamEdenA}
                              </Link>
                                <span style={{ color: '#7e7e7e' }}>/</span>
                                <Link

                                  to={"/süreç-devam-ediyor?ikiliFormat=true"}
                                >

                                  {configData && configData.devamEdenB}
                                </Link></>

                                : <Link

                                  to={"/süreç-devam-ediyor"}
                                >
                                  {configData && configData.devamEdenA}
                                </Link>}
                            </h4>

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </> : null}

                {(surecler.indexOf("tum_talepler") > -1) ? <>
                  <div className="col-xl-4 col-lg-4 col-sm-4">
                    <div className="widget-stat card bg-muted">
                      <div className="card-body p-4">
                        <div className="media">
                          <span className="mr-3 bg-light">
                            <i className="flaticon-381-user-9"></i>
                          </span>
                          <div className="media-body text-right">
                            <p className="mb-1">
                              <Link to={"/tüm-talepler"}>
                                {t("anaSayfa.tumTalepler")}
                              </Link>
                            </p>

                            <h4>
                              {(seeAll) ? <><Link
                                to={"/tüm-talepler"}
                              >
                                {configData && configData.tumuA}
                              </Link>
                                <span style={{ color: '#7e7e7e' }}>/ </span>
                                <Link
                                  to={"/tüm-talepler?ikiliFormat=true"}
                                >
                                  {configData && configData.tumuB}
                                </Link></>

                                : <Link
                                  to={"/tüm-talepler"}
                                >
                                  {configData && configData.tumuA}
                                </Link>}
                            </h4>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </> : null}

                {(surecler.indexOf("tamamlananlar") > -1) ? <>
                  <div className="col-xl-4 col-lg-4 col-sm-4">
                    <div className="widget-stat card bg-muted">
                      <div className="card-body p-4">
                        <div className="media">
                          <span className="mr-3 bg-light">
                            <i className="flaticon-381-success"></i>
                          </span>
                          <div className="media-body text-right">
                            <p className="mb-1">
                              <Link to={"/tamamlananlar"}>
                                {t("anaSayfa.tamamlananlar")}
                              </Link>
                            </p>

                            <h4>
                              {(seeAll) ? <><Link
                                to={"/tamamlananlar"}
                              >
                                {configData && configData.tamamlananA}
                              </Link>
                                <span style={{ color: '#7e7e7e' }}>/ </span>
                                <Link
                                  to={"/tamamlananlar?ikiliFormat=true"}
                                >
                                  {configData && configData.tamamlananB}
                                </Link></>

                                : <Link
                                  to={"/tamamlananlar"}
                                >
                                  {configData && configData.tamamlananA}
                                </Link>}
                            </h4>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </> : null}

                {(surecler.indexOf("reddedilenler") > -1) ? <>
                  <div className="col-xl-4 col-lg-4 col-sm-4">
                    <div className="widget-stat card bg-muted">
                      <div className="card-body p-4">
                        <div className="media">
                          <span className="mr-3 bg-light">
                            <i className="flaticon-381-close"></i>
                          </span>
                          <div className="media-body text-right">
                            <p className="mb-1">
                              <Link to={"/reddedilenler"}>
                                {t("anaSayfa.reddedilenler")}
                              </Link>
                            </p>
                            <h4>
                              {(seeAll) ? <><Link
                                to={"/reddedilenler"}
                              >
                                {configData && configData.reddedilenA}
                              </Link>
                                <span style={{ color: '#7e7e7e' }}>/ </span>
                                <Link
                                  to={"/reddedilenler?ikiliFormat=true"}
                                >
                                  {configData && configData.reddedilenB}
                                </Link></>

                                : <Link
                                  to={"/reddedilenler"}
                                >
                                  {configData && configData.reddedilenA}
                                </Link>}
                            </h4>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </> : null}

                {/* <div className="col-xl-3 col-lg-3 col-sm-3">
              <div className="widget-stat card bg-muted">
                <div className="card-body p-4">
                  <div className="media">
                    <span className="mr-3 bg-light">
                      <i className="flaticon-381-plus"></i>
                    </span>
                    <div className="media-body text-right">
                      <p className="mb-1">{t("anaSayfa.yeniTalepler")}</p>
                      <h4>
                        <Link to={"/yeni-talepler"}>
                          {configData && configData.yeniTalepler}
                        </Link>
                      </h4>
                    </div>
                  </div>
                </div>
              </div>
            </div> */}
                
                {(surecler.indexOf("atananlar") > -1) ? <>
                  <div className="col-xl-4 col-lg-4 col-sm-4">
                    <div className="widget-stat card bg-muted">
                      <div className="card-body p-4">
                        <div className="media">
                          <span className="mr-3 bg-light">
                            <i className="flaticon-381-user-9"></i>
                          </span>
                          <div className="media-body text-right">
                            <p className="mb-1">
                              <Link to={"/atananlar"}>
                                {t("anaSayfa.atananlar")}
                              </Link>
                            </p>

                            <h4>
                              {(seeAll) ? <><Link
                                to={"/atananlar"}
                              >
                                {configData && configData.atananA}
                              </Link>
                                <span style={{ color: '#7e7e7e' }}>/ </span>
                                <Link
                                  to={"/atananlar?ikiliFormat=true"}
                                >
                                  {configData && configData.atananB}
                                </Link></>

                                : <Link
                                  to={"/atananlar"}
                                >
                                  {configData && configData.atananA}
                                </Link>}
                            </h4>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </> : null}



                {<div id="notification" className={"col-xl-12 col-xxl-12 col-lg-12 col-md-12"}>
                  {
                    notificationTabStatus &&
                    <div className="card">
                      <div className="card-header border-0 pb-0">
                        <h4 className="text-dark font-w600">
                          {t("anaSayfa.duyurular")}
                        </h4>
                        <button onClick={() => changeNotificationTabStatus(false)} type="button" className="btn-xs mr-2 btn btn-primary"><i className="fa fa-close color-white"></i></button>
                      </div>
                      <div className="card-body">
                        <div className="table-responsive overflow-hidden">
                          <table className="table patient-activity">
                            <tbody>{createListforAnnouncement()}</tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  }
                </div>}
              </div>
            </div>
          </div>
        </>}
    </>
  );
}
